<template>
  <div>
    <!-- 视频组件 -->
    <el-row style="display: flex">
      <VideoUpload style="text-align: left" :video="_value" @upload-success="videoUploadSuccess" @del="videoDel" />
    </el-row>
  </div>
</template>

<script>
import storeMixins from '../store-mixins';
import VideoUpload from '@/components/Uploads/videoUpload'

export default {
  mixins: [storeMixins],
  props: ['props', 'value'],
  components: {
    VideoUpload,
  },
  computed: {
    key() {
      return this.props.name;
    },
    _value() {
      const video = this.alibabaForm[this.key];
      return video ? JSON.parse(video) : null;
    },
  },
  methods: {
    // 视频上传成功
    videoUploadSuccess(viedo) {
      this.updateAlibabaForm({
        [this.key]: JSON.stringify(viedo),
      });
    },
    // 删除视频
    videoDel() {
      this.updateAlibabaForm({
        [this.key]: '',
      });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>